import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setExceptionHandler } from '@app/store/actions';
import { basicService } from '@app/services';
import { Fade } from '@material-ui/core';
import { hasOrgPermission } from '@app/helpers';
import PwsReadyToSetup from './pwsReadyToSetup';
import PwsDownloadInstaller from './pwsDownloadInstaller';
import PwsConfigureAgent from './pwsConfigureAgent';
import PwsSyncSummary from './pwsSyncSummary';
import PwsContactAdmin from './pwsContactAdmin';
import { ManageVault } from '@app/store/constants';

const AgentOnboardingStartPage = () => {
    const [currentStep, setCurrentStep] = useState(hasOrgPermission([ManageVault]) ? 1 : 6);
    const [agentId, setAgentId] = useState('');

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setExceptionHandler(true));
    }, []);

    const onNext = () => {
        setCurrentStep(currentStep + 1);
    };

    const onClose = () => {
        basicService.redirect('/passwordserver/agents');
    }

    return (
        <>
            {currentStep === 1 &&
                <Fade in={true}
                    timeout={1000}>
                    <div>
                        <PwsReadyToSetup onNext={onNext} />
                    </div>
                </Fade>
            }

            {currentStep === 2 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <PwsDownloadInstaller onNext={onNext} onCancel={onClose} setAgent={setAgentId} />
                    </div>
                </Fade>
            }

            {currentStep === 3 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <PwsConfigureAgent onNext={onNext} onCancel={onClose} agentId={agentId} />
                    </div>
                </Fade>
            }

            {currentStep === 4 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <PwsSyncSummary onClose={onClose} />
                    </div>
                </Fade>
            }

            {currentStep === 5 &&
                <Fade
                    in={true}
                    timeout={1000}>
                    <div>
                        <PwsContactAdmin onClose={onClose} />
                    </div>
                </Fade>
            }
        </>
    );
};

export default AgentOnboardingStartPage;
